import {ReactNode} from "react";
import "./form-section.css";

interface FormSectionProps {
    children: ReactNode | ReactNode[];
    title?: string;
    className?: string;
}

const FormSection = ({ children, title, className = "" }: FormSectionProps) => {
    return (
        <div className={`form-section ${className}`}>
            {title ? <div className="title">{title}</div> : null}
            {children}
        </div>
    );
}

export default FormSection;